import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CartBaseModule } from '@spartacus/cart/base';
import { AddToCartModule } from '@spartacus/cart/base/components/add-to-cart';
import { MiniCartModule } from '@spartacus/cart/base/components/mini-cart';
import { ConfigModule, I18nConfig, I18nModule, provideConfig } from '@spartacus/core';
import { AppRoutingModule, LogoutGuard } from '@spartacus/storefront';
import { environment } from 'src/environments/environment';
import { ComponentsModule } from './components/components.module';
import { uigRoutesConfig } from './config/uig-routes.config';
import { UigOrganizationComponentsModule } from './organization/uig-organization-components.module';
import { ServicesModule } from './services/services.module';
import { UigAnalyticsService } from './services/uig-analytics.service';
import { SpartacusModule } from './spartacus/spartacus.module';
import { UigMyAccountModule } from './uig-my-account/uig-my-account.module';
import { uigI18nOverrides } from '../assets/i18n-assets/uig-i18n-translations';
import { UIGBaseSiteResponseInterceptor } from './services/http-interceptors/uig-basesite-response.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UIGLogoutGuard } from './guards/uig-logout.guard';

registerLocaleData(localeEn);
registerLocaleData(localeDe);

@NgModule({
  imports: [
    I18nModule,
    CartBaseModule,
    AddToCartModule,
    AppRoutingModule,
    MiniCartModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    SpartacusModule,
    StoreDevtoolsModule.instrument({
      logOnly: environment.production,
      connectInZone: true,
    }),
    ComponentsModule,
    ServicesModule,
    UigMyAccountModule,
    UigOrganizationComponentsModule,
    ConfigModule.withConfig({
      routing: {
        protected: true,
        routes: uigRoutesConfig,
      },
    }),
  ],
  providers: [
    UigAnalyticsService.initializeProvider,
    provideConfig(<I18nConfig>{
      i18n: { resources: uigI18nOverrides },
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UIGBaseSiteResponseInterceptor,
      multi: true,
    },
    {
      provide:LogoutGuard,
      useClass:UIGLogoutGuard
    }
  ],
})
export class AppModule {}
